import React from "react";

export const AmendmentContext = React.createContext({});
